import type {SessionFeedback} from '../net/online';
import {GEAR} from './character';
import {itemName} from './huntEconomy';
import type {FeedbackEvent} from './feedbackQueue';

/** Only committed server events produce success/reward messages. */
export function presentFeedback(event:SessionFeedback,at:number):FeedbackEvent|undefined {
 if(event.kind==='error')return{id:event.id,kind:'error',text:event.text,at};
 if(event.kind==='reward'){
  const parts=[event.exp>0?`EXP +${event.exp}`:'',event.bie>0?`เบี้ย +${event.bie}`:'',event.spirit>0?`แก่นวิญญาณ +${event.spirit}`:''].filter(Boolean);
  return parts.length?{id:event.id,kind:'reward',text:'ได้รับรางวัล · '+parts.join(' · '),at}:undefined;
 }
 if(event.action==='bind')return{id:event.id,kind:'success',text:'เซิร์ฟเวอร์ยืนยันจัดช่องลัดแล้ว · ล็อกช่องก่อนต่อสู้',at,group:'bind'};
 if(event.action==='mail-claim')return{id:event.id,kind:'reward',text:'รับของจากจดหมายแล้ว · ตรวจในกระเป๋า',at};
 const [itemId,quantity]=event.value.split(':');
 const name=GEAR.find(g=>g.id===itemId)?.name??itemName(itemId??'');
 const text=event.action==='equip'?'สวมใส่ '+name+' แล้ว':event.action==='unequip'?'ถอด '+name+' แล้ว':event.action==='potion'?'ใช้น้ำยาฟื้นกายแล้ว':event.action==='buy'?'ซื้อ '+name+' แล้ว':event.action==='merchant-buy'?'ซื้อ '+name+' ×'+(quantity??'1')+' แล้ว':event.action==='merchant-sell'?'ขาย '+name+' ×'+(quantity??'1')+' แล้ว':event.action==='buy-warp'?'ซื้อยันต์ข้ามแดนแล้ว':event.action==='warp-item'?'ใช้ยันต์ข้ามแดนแล้ว':undefined;
 return text?{id:event.id,kind:'success',text,at,group:event.action}:undefined;
}
